<button class="handle">
	<div *ngIf="!enableLock" class="menu-btn" (click)="toggle()" (mouseout)="onMouseOut()" (mousedown)="onMouseDown()">
		<img *ngIf="toggled" [src]="closeHandle" />
		<img *ngIf="!toggled" [src]="openHandle" />
	</div>
	<img *ngIf="enableLock" class="menu-btn-lock" [src]="imgSrcLock" />
</button>
